/** Typed access to build-time environment variables. */
const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim() ?? '';
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim() ?? '';
const forceDemo = String(import.meta.env.VITE_FORCE_DEMO ?? 'false') === 'true';

export const env = {
  supabaseUrl: url,
  supabaseAnonKey: anonKey,
  documentsBucket: (import.meta.env.VITE_SUPABASE_DOCUMENTS_BUCKET as string | undefined) || 'tender-documents',
  /** True when real Supabase credentials are present and demo is not forced. */
  isSupabaseConfigured: Boolean(url && anonKey) && !forceDemo,
} as const;

export const APP_NAME = 'Tender & Contract Management System';
export const APP_SHORT_NAME = 'TCMS';
